// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-tooltip{background-color:#fff!important;max-width:500px;border-radius:0;padding:6px}", ""]);
// Exports
module.exports = exports;
